import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { exportGrid, exportFormats } from 'utils/exportGridConfig';
import { onEditorPreparing } from 'utils/tableHelper';

import DataGrid, { GroupPanel, Paging, SearchPanel, FilterRow, HeaderFilter, Export } from 'devextreme-react/data-grid';
const Table = forwardRef(
    (
        {
            classes,
            data,
            columns,
            rowsPerPage,
            optionChangedHandler,
            disabled,
            focusedRowKey,
            onDoubleClick,
            showSearchPanel = true,
            groupPanel = true,
            filterRow = true,
            exportData = true,
            showColumnLines = true,
            showRowLines = true,
            showBorders = true,
            headerFilter = true,
            rowAlternationEnabled = true,
            exportFileName = 'DataGrid',
        },
        ref
    ) => {
        const focusedRow = focusedRowKey ? { focusedRowKey } : null;

        return (
            <DataGrid
                ref={ref}
                disabled={disabled}
                dataSource={data}
                keyExpr="id"
                allowColumnReordering={false}
                showColumnLines={showColumnLines}
                showRowLines={showRowLines}
                showBorders={showBorders}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode="widget"
                columnAutoWidth={true}
                rowAlternationEnabled={rowAlternationEnabled}
                loadPanel={{ enabled: true }}
                onOptionChanged={optionChangedHandler}
                {...focusedRow}
                className={classes}
                onRowDblClick={onDoubleClick}
                onExporting={(e) => exportGrid(e, exportFileName)}
                onEditorPreparing={onEditorPreparing}
            >
                <GroupPanel visible={groupPanel} />
                <SearchPanel visible={showSearchPanel} />
                <Paging defaultPageSize={rowsPerPage} mode="full" showNavigtionButtons={true} />

                <FilterRow visible={filterRow} />
                <HeaderFilter visible={headerFilter} />
                {columns}

                <Export enabled={exportData} allowExportSelectedData={false} formats={exportFormats} />
            </DataGrid>
        );
    }
);

Table.displayName = 'Table';
Table.propTypes = {
    classes: PropTypes.string,
    data: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    rowsPerPage: PropTypes.number,
    optionChangedHandler: PropTypes.func,
    disabled: PropTypes.bool,
    focusedRowKey: PropTypes.any,
    onDoubleClick: PropTypes.func,
    showSearchPanel: PropTypes.bool,
    groupPanel: PropTypes.bool,
    filterRow: PropTypes.bool,
    exportData: PropTypes.bool,
    showColumnLines: PropTypes.bool,
    showRowLines: PropTypes.bool,
    showBorders: PropTypes.bool,
    headerFilter: PropTypes.bool,
    rowAlternationEnabled: PropTypes.bool,
    exportFileName: PropTypes.string,
};

export default Table;
